// extracted by mini-css-extract-plugin
module.exports = {"slider":"kF","lightBg":"kG","sliderLink":"kH","sliderTitle":"kI","sliderTitleSelected":"kJ","centerMenu":"kK"};